import React, { useState, useEffect } from 'react';
import { GeckoModal, GeckoModalService, GeckoFields, GeckoBtn } from 'ui';

const TalkToSupportModal = () => {
  const handleClick = () => {
    window.Intercom('show');
    new GeckoModalService().close();
  };
  return (
    <div>
      <GeckoModal name="Create a Bot">
        <div style={{ paddingBottom: '20px' }}>
          <span>Please contact support in order to create a bot</span>
        </div>
        <GeckoBtn
          type={'primary'}
          name={'Contact Support'}
          handler={handleClick}
        />
      </GeckoModal>
    </div>
  );
};

export default TalkToSupportModal;
